import { addErrorNotification, addInfoNotification } from "./notify.actions";

export const allocationCloseInfoNotification = (e) => async (dispatch) => {
  dispatch(addInfoNotification({ text: e }));
};

export const allocationCloseErrorNotification = (e) => async (dispatch) => {
  dispatch(addErrorNotification({ text: e }));
};
